import {
  CAR_DATA_CATALOGO_CREATE_FILE_ASSOCIATION_BEGIN,
  CAR_DATA_CATALOGO_CREATE_FILE_ASSOCIATION_FAILURE
} from './constants'
import { BFFAgent } from 'BFFAgent'

export function createFileAssociations(files, id, body, isUsed) {
  return async dispatch => {
    dispatch({
      type: CAR_DATA_CATALOGO_CREATE_FILE_ASSOCIATION_BEGIN
    })

    try {
      await BFFAgent.Catalogs.addFileWhenCreate(files, id, body, isUsed)

    } catch {
      dispatch({
        type: CAR_DATA_CATALOGO_CREATE_FILE_ASSOCIATION_FAILURE
      })
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_CATALOGO_CREATE_FILE_ASSOCIATION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        errorAssociation: false
      }

    case CAR_DATA_CATALOGO_CREATE_FILE_ASSOCIATION_FAILURE:
      // The request is failed
      return {
        ...state,
        errorAssociation: true
      }

    default:
      return state
  }
}
